/**
 * Core
 */
import React from "react";
/**
 * Styles
 */
import "./InputGlobal.scss";

function InputGlobal({
  placeholder,
  className,
  name,
  type,
  onChange,
  id,
  value,
}) {
  return (
    <input
      autoComplete="off"
      type={type}
      placeholder={placeholder}
      className={className}
      name={name}
      onChange={onChange}
      id={id}
      value={value}
    />
  );
}

export default InputGlobal;
